//@flow
import React, { type Element, type Node } from 'react';

import * as InventoryTag from '../inventoryTags/InventoryTag';
import { PlaceholderText } from '../Placeholder';
import Heading from '../Heading';

const Activities = ({activities}: {activities: {name: string}[]}) =>
    activities && activities.map(({ name }) => (
        <li key={name} className="rec-park-pill">
            {name}
        </li>
    ));

type PropTypes = {
    activities: {name: string}[],
    isLoading: boolean,
    title: string,
    partOf?: { url?: string, title: string },
    starRating?: Element<*> & { rating: string },
    cellRating?: Node,
    inventoryType: string,
}
const FacilityPageHeader = ({activities, isLoading, title, partOf, starRating, cellRating, inventoryType}: PropTypes) => {
    const Tag = InventoryTag[`Inventory${inventoryType}`];
    if(isLoading) {
        return (
            <div className="permit-facility-page-header">
                <PlaceholderText fontSize={33} lineHeight={39} />
                <ul className="rec-subhead-wrap">
                    <li key={'partof-placeholder'}>
                        <PlaceholderText fontSize={19} lineHeight={23} width="195px" />
                    </li>
                    <li key={'rating-placeholder'} className="rec-subhead-rating">
                        <PlaceholderText fontSize={19} lineHeight={23} width="175px" />
                    </li>
                    <li className="rec-subhead-cell-rating">
                        <PlaceholderText fontSize={19} lineHeight={23} width="160px" />
                    </li>
                </ul>
                <ul className="rec-inventory-tags rec-pill-wrap">
                    {<Tag />}
                    <Activities activities={[]} />
                </ul>
            </div>
        )
    }
    return (
        <div className="permit-facility-page-header">
            {/* Main title of the page */}
            {title && (
                <Heading headingLevel={1} appearance="h3" className="mb-1">
                    {title}
                </Heading>
            )}

            {/* "Part of" statement and star rating */}
            <ul className="rec-subhead-wrap">
                <li key={partOf?.url}>
                    Part of <a href={partOf?.url}>{partOf?.title}</a>
                </li>
                
                {starRating && (
                    <li key={`rating-${starRating?.rating}`} className="rec-subhead-rating">
                        {starRating}
                    </li>
                )}
                {cellRating && (
                    <li className="rec-subhead-cell-rating">
                        {cellRating}
                    </li>
                )}
            </ul>
            {/* Pills and icons */}
            <ul className="rec-inventory-tags rec-pill-wrap">
                {<Tag />}
                <Activities activities={activities} />
            </ul>
        </div>
    );
}

export default FacilityPageHeader;